import { Component } from '@angular/core';
import { AuthService } from '_services/auth.service';
import { Router, RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [RouterOutlet]
})
export class AppComponent {
  constructor(
    public authService: AuthService,
    public router: Router,
  ) {
  }

  // HostListener when navigating away from page to logout auth
  // TODO: EPL - Enable to logout when navigating away from page since EPL will handle auth
  // @HostListener('window:beforeunload', ['$event'])
  // beforeUnloadHandler() {
  //   this.authService.user.pipe(
  //     take(1),
  //     tap(user => {
  //       if (user && !user.admin) {
  //         this.authService.logout(false);
  //       }
  //     })
  //   ).subscribe();
  // }

}
